import { MOBILE_MQ } from '../../theme/mobileLayout'

/** Figma mobile artboard 76:4336 — Contact page tokens */
export { MOBILE_MQ as CONTACT_MOBILE_MQ }

export const contactMobileHeroTitleSx = {
  [MOBILE_MQ]: {
    fontSize: 40,
    mb: '16px',
  },
}

export const contactMobileHeroSubtitleSx = {
  [MOBILE_MQ]: {
    fontSize: 20,
    lineHeight: 'normal',
  },
}

export const contactMobileSectionTitleSx = {
  [MOBILE_MQ]: {
    fontSize: 26,
  },
}

export const contactMobileCardTitleSx = {
  [MOBILE_MQ]: {
    fontSize: 22,
  },
}

export const contactMobileCardBodySx = {
  [MOBILE_MQ]: {
    fontSize: 14,
    lineHeight: 'normal',
  },
}

export const contactMobileFormLabelSx = {
  [MOBILE_MQ]: {
    fontSize: 14,
  },
}

export const contactMobileFormInputSx = {
  [MOBILE_MQ]: {
    fontSize: 14,
    py: '16px',
  },
}

export const contactMobileFormGap = {
  [MOBILE_MQ]: {
    gap: '20px',
  },
}

export const contactMobileCardsGap = {
  [MOBILE_MQ]: {
    gap: '20px',
  },
}

export const contactMobileFormSectionGap = {
  [MOBILE_MQ]: {
    gap: '32px',
  },
}

export const contactMobileSubmitButtonSx = {
  [MOBILE_MQ]: {
    height: 41,
    minHeight: 41,
    fontSize: 12,
    lineHeight: '12px',
    p: '14px',
  },
}

/** Social tiles — single row, ~52px each */
export const contactMobileSocialTileSx = {
  [MOBILE_MQ]: {
    flex: '1 1 0',
    minWidth: 0,
    aspectRatio: '1 / 1',
    maxHeight: 52,
    borderRadius: '9px',
    p: '4.5px',
  },
}

export const contactMobileSocialIconSx = {
  [MOBILE_MQ]: {
    width: 36,
    height: 36,
    maxWidth: '100%',
    maxHeight: '100%',
  },
}

export const contactMobileSocialRowSx = {
  [MOBILE_MQ]: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: '11px',
    width: '100%',
  },
}
